<template>
    <div>
        <b-form-group label-for="dias" class="mt-2">
            <b-form-group class="form-check form-check-inline">
                <b-form-checkbox v-model="insClientEe" :value="1" :disabled="disabled">
                    ¿Parte de inst EE dentro del cliente?
                </b-form-checkbox>
            </b-form-group>
        </b-form-group>
    </div>
</template>

<script>
import {BFormGroup, BFormCheckbox} from 'bootstrap-vue'

export default {
    components: {
        BFormGroup,
        BFormCheckbox,
    },
    props: {
        insClientEe: {
            type: Number,
            default: 1
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            localInsClientEe: this.insClientEe,
        }
    },
    watch: {
        insClientEe(newVal) {
            this.localInsClientEe = newVal
            this.$emit('update', { ins_client_ee: this.localInsClientEe })
        },
    },
}
</script>
